<template>
  <div 
    :class="['nodo',(nodo.id == 1)?'nodo_principal':'',(ultimo)?'ultimo':'',(nodo.comprable)?'comprable':'']"
    @click="visible = !visible"
    >
    Nodo {{nodo.titulo}}
    <nodo 
      v-if="visible || nodo.id == 1"
      style="margin-left: 20px;"
      v-for="(nod,index) in nodo.hijos" 
      :key="nod.id" 
      :nodo="nod" 
      :ultimo="(index == nodo.hijos.length - 1)?true:false"
      ></nodo>
  </div>
</template>

<script>
//import JQuery from 'jquery'
//let $ = JQuery
import vSelect from 'vue-select'

export default {
  name:"nodo",
  data() {
    return {
      visible: false
    }
  },
  props: {
    nodo: Object,
    ultimo: Boolean
  },
  computed: {

  },
  mounted(){

  },
  methods: {

  },
  components: {
    'v-select': vSelect,
  }
}
</script>

